export const pageTitles = (key) => {
    const labelMap = {
        'dashboard': 'Dashboard',
        'siteManagement': 'Site Management',
        'allSites': 'All Sites',
        'createSite': 'Create Site',
        'editSite': 'Edit Site',
        'siteDetails': 'Site Details',
        'importSites': 'Import Sites',
        'blacklist': 'Blacklist',
        'orderManagement': 'Order Management',
        'allOrders': 'All Orders',
        'createOrder': 'Create Order',
        'allBudgets': 'Budgets',
        'createBudget': 'Create Budget',
        'editBudget': 'Edit Budget',
        'editOrder': 'Edit Order',
        'orderDetails': 'Order Details',
        'orderAdministration': 'Order Administration',
        'contentReview': 'Content Review',
        'orderPublication': 'Publication',
        'liveLink': 'Live Link',
        'orderInvoice': 'Invoice',
        'invoiceManagement': 'Invoice Management',
        'allInvoices': 'All Invoices',
        'editInvoice': 'Edit Invoice',
        'userManagement': 'User Management',
        'clients': 'Clients',
        'addClient': 'Add Client',
        'editClient': 'Edit Client',
        'clientDetails': 'Client Details',
        'sellerManagement': 'Seller Management',
        'allSellers': 'All Sellers',
        'addSeller': 'Add Seller',
        'editSeller': 'Edit Seller',
        'sellerDetails': 'Seller Details',
        'categoriesManagement': 'Categories Management',
        'allCategories': 'All Categories',
        'addCategory': 'Add Category',
        'editCategory': 'Edit Category',
        'categoryDetails': 'Category Details',
        'typesManagement': 'Niches Management',
        'allTypes': 'All Niches',
        'addType': 'Add Niche',
        'editType': 'Edit Niche',
        'typeDetails': 'Niche Details',
        'languagesManagement': 'Languages Management',
        'allLanguages': 'All Languages',
        'addLanguage': 'Add Language',
        'editLanguage': 'Edit Language',
        'languageDetails': 'Language Details',
        'exchangeRates': 'Exchange Rates',
        'allExchangeRates': 'All Exchange Rates',
        'addExchangeRate': 'Add Exchange Rate',
        'editExchangeRate': 'Edit Exchange Rate',
        'exchangeDetails': 'Exchange Details',
        'countriesManagement': 'Countries Management',
        'allCountries': 'All Countries',
        'addCountry': 'Add Country',
        'editCountry': 'Edit Country',
        'countryDetails': 'Country Details',
        'teamsManagement': 'Teams Management',
        'allTeams': 'All Teams',
        'addTeam': 'Add Team',
        'editTeam': 'Edit Team',
        'teamDetails': 'Team Details',
        'teamMemberDetails': 'Team Member Details',
        'contentManagement': 'Content Management',
        'banners': 'Banners',
        'createBanner': 'Create Banner',
        'editBanner': 'Edit Banner',
        'newsPosts': 'News Posts',
        'createNews': 'Create News',
        'editNews': 'Edit News',
        'system': 'System',
        'audits': 'Audits',
        'auditDetails': 'Audit Details',
        'profile': 'Profile',
        'settings': 'Settings',
        'newsletter': 'Newsletter',
        'emailSettings': 'Email Settings',
        'companiesManagement': 'Companies',
        'allCompanies': 'All Companies',
        'addCompany': 'Add Company',
        'editCompany': 'Edit Company',
        'bankAccountsManagement': 'Bank Accounts',
        'allBankAccounts': 'All Bank Accounts',
        'addBankAccount': 'Add Bank Account',
        'editBankAccount': 'Edit Bank Account'
    };
    return labelMap[key] || key;
};

// Route name (exact or dot-prefix) -> pageTitles key. Single source for the
// header page title and the "Admin - <Page>" document title in AdminMainLayout.
const routeTitleMap = {
    'dashboard': 'dashboard',
    'sites': 'siteManagement',
    'site-blacklist': 'blacklist',
    'orders': 'orderManagement',
    'order-content': 'orderManagement',
    'order-items': 'orderManagement',
    'order-item': 'orderManagement',
    'budgets': 'allBudgets',
    'clients': 'userManagement',
    'sellers': 'sellerManagement',
    'categories': 'categoriesManagement',
    'types': 'typesManagement',
    'languages': 'languagesManagement',
    'countries': 'countriesManagement',
    'teams': 'teamsManagement',
    'exchanges': 'exchangeRates',
    'invoices': 'invoiceManagement',
    'content': 'contentManagement',
    'banners': 'contentManagement',
    'news': 'contentManagement',
    'admin.newsletter': 'contentManagement',
    'audits': 'system',
    'admin.email-settings': 'system',
    'admin.formula-tax': 'system',
    'admin.payment-tax': 'system',
    'admin.global-fixed': 'system',
    'admin.wise-bank-account': 'system',
    'companies': 'companiesManagement',
    'bank-accounts': 'bankAccountsManagement',
    'profile': 'settings',
};

export const pageTitleForRoute = (routeName) => {
    if (!routeName) return null;
    const prefix = Object.keys(routeTitleMap).find((p) => routeName === p || routeName.startsWith(`${p}.`));
    return prefix ? pageTitles(routeTitleMap[prefix]) : null;
};

const adminMenu = [
    {
        label: 'Admin Dashboard',
        icon: 'pi pi-home',
        items: [
            {
                label: 'Overview',
                icon: 'pi pi-fw pi-chart-line',
                route: 'dashboard'
            },
            // {
            //     label: 'Analytics',
            //     icon: 'pi pi-fw pi-chart-bar',
            //     route: 'analytics'
            // }
        ]
    },
    {
        label: pageTitles('siteManagement'),
        icon: 'pi pi-globe',
        items: [
            {
                label: pageTitles('allSites'),
                icon: 'pi pi-fw pi-list',
                route: 'sites.index'
            },
            {
                label: pageTitles('createSite'),
                icon: 'pi pi-fw pi-plus',
                route: 'sites.create'
            },
            {
                label: pageTitles('importSites'),
                icon: 'pi pi-fw pi-upload',
                route: 'sites.import.show'
            },
            {
                label: pageTitles('blacklist'),
                icon: 'pi pi-fw pi-ban',
                route: 'site-blacklist.index'
            },
            // {
            //     label: 'Site Offers',
            //     icon: 'pi pi-fw pi-handshake',
            //     route: 'sites.offers'
            // }
        ]
    },
    {
        label: pageTitles('orderManagement'),
        icon: 'pi pi-shopping-cart',
        items: [
            {
                label: pageTitles('allOrders'),
                icon: 'pi pi-fw pi-check-square',
                route: 'orders.index'
            },
            {
                label: pageTitles('createOrder'),
                icon: 'pi pi-fw pi-plus',
                route: 'orders.create'
            },
            {
                label: pageTitles('allBudgets'),
                icon: 'pi pi-fw pi-file-edit',
                route: 'budgets.index'
            }
        ]
    },
    {
        label: pageTitles('invoiceManagement'),
        icon: 'pi pi-file-pdf',
        items: [
            {
                label: pageTitles('allInvoices'),
                icon: 'pi pi-fw pi-list',
                route: 'invoices.index'
            }
        ]
    },
    {
        label: pageTitles('userManagement'),
        icon: 'pi pi-users',
        items: [
            {
                label: pageTitles('clients'),
                icon: 'pi pi-fw pi-user',
                route: 'clients.index'
            },
            {
                label: pageTitles('addClient'),
                icon: 'pi pi-fw pi-user-plus',
                route: 'clients.create'
            },
        ]
    },
    {
        label: pageTitles('sellerManagement'),
        icon: 'pi pi-briefcase',
        items: [
            {
                label: pageTitles('allSellers'),
                icon: 'pi pi-fw pi-users',
                route: 'sellers.index'
            },
            {
                label: pageTitles('addSeller'),
                icon: 'pi pi-fw pi-user-plus',
                route: 'sellers.create'
            }
        ]
    },
    {
        label: pageTitles('categoriesManagement'),
        icon: 'pi pi-fw pi-tags',
        items: [
            {
                label: pageTitles('allCategories'),
                icon: 'pi pi-fw pi-list',
                route: 'categories.index'
            },
            {
                label: pageTitles('addCategory'),
                icon: 'pi pi-fw pi-plus',
                route: 'categories.create'
            }
        ]
    },
    {
        label: pageTitles('typesManagement'),
        icon: 'pi pi-fw pi-th-large',
        items: [
            {
                label: pageTitles('allTypes'),
                icon: 'pi pi-fw pi-list',
                route: 'types.index'
            },
            {
                label: pageTitles('addType'),
                icon: 'pi pi-fw pi-plus',
                route: 'types.create'
            }
        ]
    },
    // {
    //     label: 'Categories',
    //     icon: 'pi pi-cog',
    //     items: [
    //         {
    //             label: 'All Categories',
    //             icon: 'pi pi-fw pi-history',
    //             route: 'audits.index'
    //         },
    //         {
    //             label: 'Add Categorie',
    //             icon: 'pi pi-fw pi-history',
    //             route: 'audits.index'
    //         }
    //     ]
    // },
    // {
    //     label: 'Types',
    //     icon: 'pi pi-cog',
    //     items: [
    //         {
    //             label: 'All Types',
    //             icon: 'pi pi-fw pi-history',
    //             route: 'audits.index'
    //         },
    //         {
    //             label: 'Add Type',
    //             icon: 'pi pi-fw pi-history',
    //             route: 'audits.index'
    //         }
    //     ]
    // },
    {
        label: pageTitles('languagesManagement'),
        icon: 'pi pi-fw pi-language',
        items: [
            {
                label: pageTitles('allLanguages'),
                icon: 'pi pi-fw pi-list',
                route: 'languages.index'
            },
            {
                label: pageTitles('addLanguage'),
                icon: 'pi pi-fw pi-plus',
                route: 'languages.create'
            }
        ]
    },
    {
        label: pageTitles('exchangeRates'),
        icon: 'pi pi-fw pi-dollar',
        items: [
            {
                label: pageTitles('allExchangeRates'),
                icon: 'pi pi-fw pi-list',
                route: 'exchanges.index'
            },
            {
                label: pageTitles('addExchangeRate'),
                icon: 'pi pi-fw pi-plus',
                route: 'exchanges.create'
            }
        ]
    },
    {
        label: pageTitles('countriesManagement'),
        icon: 'pi pi-fw pi-globe',
        items: [
            {
                label: pageTitles('allCountries'),
                icon: 'pi pi-fw pi-list',
                route: 'countries.index'
            },
            {
                label: pageTitles('addCountry'),
                icon: 'pi pi-fw pi-plus',
                route: 'countries.create'
            }
        ]
    },
    {
        label: pageTitles('contentManagement'),
        icon: 'pi pi-megaphone',
        items: [
            {
                label: pageTitles('banners'),
                icon: 'pi pi-fw pi-image',
                route: 'content.banners.index'
            },
            {
                label: pageTitles('newsPosts'),
                icon: 'pi pi-fw pi-book',
                route: 'content.news.index'
            },
            {
                label: pageTitles('newsletter'),
                icon: 'pi pi-fw pi-send',
                route: 'admin.newsletter.index'
            }
        ]
    },
    {
        label: pageTitles('system'),
        icon: 'pi pi-cog',
        items: [
            {
                label: pageTitles('emailSettings'),
                icon: 'pi pi-fw pi-envelope',
                route: 'admin.email-settings.index'
            },
            {
                label: pageTitles('allCompanies'),
                icon: 'pi pi-fw pi-building',
                route: 'companies.index'
            },
            {
                label: pageTitles('allBankAccounts'),
                icon: 'pi pi-fw pi-wallet',
                route: 'bank-accounts.index'
            }
        ]
    },

];

export default adminMenu;
